import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputMask } from "primereact/inputmask";
import { InputText } from "primereact/inputtext";
import { MultiSelect } from "primereact/multiselect";
import { InputTextarea } from "primereact/inputtextarea";

const imgStyle = {
  width: 20,
  height: 20,
  borderRadius: 10,
};

const optionContainer = {
  gap: 10,
  display: "flex",
  alignItems: "center",
};

export default function RenderInput({
  type,
  chip,
  mask,
  error,
  label,
  large,
  ref,
  small,
  style,
  options,
  filterBy,
  leftIcon,
  rightIcon,
  floatLabel,
  dateFormat,
  placeholder,
  tooltipPosition,

  ...rest
}) {
  const sizeClass = `p-d-block app-input ${error && `p-invalid`} ${
    rest.showMode && "no-borders"
  } p-inputtext${small && `-sm`} ${large && `-lg`}`;

  const inputStyle = {
    width: "100%",
    paddingLeft: leftIcon && "2.5em",
    paddingRight:
      rightIcon && (type === "dropdown" || type === "time" ? "3.2em" : "2.5em"),
    ...style,
  };

  const selectedTemplate = (option) => {
    if (option) {
      return (
        <div
          className="country-item country-item-value"
          style={optionContainer}
        >
          {type !== "time" && option.src && (
            <img
              alt=""
              style={imgStyle}
              src={option.src}
              className={`flag flag-${
                type === `time`
                  ? option.toLowerCase()
                  : option.code.toLowerCase()
              }`}
              onError={(e) => (e.target.src = null)}
            />
          )}
          <div>
            {option.name || option.time} {"\u00a0"}{" "}
          </div>
        </div>
      );
    }

    return <span>{placeholder}</span>;
  };

  const optionTemplate = (option) => {
    return (
      <div className="country-item" style={optionContainer}>
        {type !== "time" && option.src && (
          <img
            alt=""
            style={imgStyle}
            src={option.src}
            onError={(e) => (e.target.src = null)}
            className={`flag flag-${
              type === "time" ? option.toLowerCase() : option.code.toLowerCase()
            }`}
          />
        )}
        <div>{option.name || option.time}</div>
      </div>
    );
  };

  const renderContent = () => {
    switch (type) {
      case "mask":
        return (
          <InputMask
            ref={ref}
            mask={mask}
            style={inputStyle}
            className={sizeClass}
            placeholder={(!floatLabel && mask) || ""}
            tooltipOptions={{ position: tooltipPosition }}
            readOnly={rest.showMode || rest.readOnly}
            disabled={rest.showMode | rest.disabled}
            {...rest}
          ></InputMask>
        );
      case "textArea":
        return (
          <InputTextarea
            ref={ref}
            style={inputStyle}
            className={sizeClass}
            placeholder={(!floatLabel && placeholder) || ""}
            tooltipOptions={{ position: tooltipPosition }}
            readOnly={rest.showMode || rest.readOnly}
            disabled={rest.showMode | rest.disabled}
            {...rest}
          />
        );
      case "date":
        return (
          <Calendar
            ref={ref}
            // showButtonBar
            inputClassName={sizeClass}
            inputStyle={inputStyle}
            dateFormat={rest.dateFormat || "dd/mm/yy"}
            disabled={rest.showMode | rest.disabled}
            tooltipOptions={{ position: tooltipPosition }}
            placeholder={
              (!floatLabel && (dateFormat ? dateFormat : placeholder)) || ""
            }
            readOnly={rest.showMode || rest.readOnly}
            {...rest}
          />
        );

      case "dropdown":
        return (
          <Dropdown
            ref={ref}
            filter
            showClear={
              (!rest.noClear && !rest.showMode && Boolean(rest.value)) || false
            }
            options={options}
            style={inputStyle}
            className={sizeClass}
            optionLabel={filterBy || "name"}
            itemTemplate={optionTemplate}
            filterPlaceholder="Search"
            readOnly={rest.showMode || rest.readOnly}
            disabled={rest.showMode | rest.disabled}
            valueTemplate={selectedTemplate}
            placeholder={
              placeholder ||
              (!floatLabel && placeholder && "select an item") ||
              ""
            }
            {...rest}
          />
        );
      case "multi":
        return (
          <MultiSelect
            ref={ref}
            filter
            showClear={!rest.noClear || false}
            display="chip"
            options={options}
            style={inputStyle}
            optionLabel={filterBy}
            itemTemplate={optionTemplate}
            className={`multiselect-custom ${sizeClass}`}
            selectedItemTemplate={!chip && selectedTemplate}
            placeholder={placeholder || (!floatLabel && "select items") || ""}
            readOnly={rest.showMode || rest.readOnly}
            disabled={rest.showMode | rest.disabled}
            {...rest}
          />
        );

      default:
        return (
          <InputText
            ref={ref}
            autoComplete={rest.autoComplete || "none"}
            style={inputStyle}
            className={sizeClass}
            placeholder={(!floatLabel && placeholder) || ""}
            tooltipOptions={{ position: tooltipPosition }}
            readOnly={rest.showMode || rest.readOnly}
            disabled={rest.showMode | rest.disabled}
            {...rest}
          />
        );
    }
  };

  return (
    <div className="p-grid p-fluid">
      <div className="p-col-12" style={{ marginTop: 25 }}>
        <span className="p-float-label">
          {renderContent()}
          {floatLabel && label && (
            <label
              htmlFor={label}
              style={{
                color: "#888",
                marginBottom: 2,
                paddingLeft: leftIcon && 30,
              }}
            >
              {label}
            </label>
          )}
        </span>
      </div>
    </div>
  );
}
